import {
  MDBCol,
  MDBDatatable,
  MDBRow,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdb-react-ui-kit";
import React from "react";

function BillingContractSeatReport({
  contractSeatInfo,
  seatSummary,
  isContractAccount,
  accountSeatSummary,
}) {
  const billingData = {
    columns: [
      { label: "Service Name", field: "service_name" },
      { label: "Present Seats", field: "present_seats" },
      { label: "Used Days", field: "used_days" },
      { label: "Monthly Rate($)", field: "monthly_rate" },
      { label: "Prorated Seat Charges($)", field: "prorated_seat_charge" },
    ],
    rows: seatSummary,
  };
  const billingDataContract = {
    columns: [
      { label: "Seat Type", field: "seat_type" },
      ...(isContractAccount === 1
        ? [
            { label: "Contract Seats Quantity", field: "contrct_seat_count" },
            {
              label: "Non-Contract Seats Quantity",
              field: "noncontrct_seat_count",
            },
          ]
        : []),
      { label: "Total Quantity", field: "total_seat_count" },
    ],
    rows: contractSeatInfo,
  };
  return (
    <>
      <div className="my-3">
        {accountSeatSummary && (
          <>
            <MDBRow className="mb-4">
              {accountSeatSummary.acc_usr_seat_count && (
                <MDBCol style={{ width: "25%" }}>
                  <div className="p-3 border border-2  rounded-5 shadow-2-strong d-flex align-items-center justify-content-center flex-column">
                    <h1 className="m-0">
                      {accountSeatSummary?.acc_usr_seat_count?.count ?? "0/0"}
                    </h1>
                    <p>
                      {accountSeatSummary?.acc_usr_seat_count?.label_text ?? ""}
                    </p>
                  </div>
                </MDBCol>
              )}
              {/* {accountSeatSummary?.smartbox_usr_seat_count && (
                <MDBCol style={{ width: "25%" }}>
                  <div className="p-3 border border-2  rounded-5 shadow-2-strong d-flex align-items-center justify-content-center flex-column">
                    <h1 className="m-0">
                      {accountSeatSummary?.smartbox_usr_seat_count?.count ??
                        "0/0"}
                    </h1>
                    <p>
                      {accountSeatSummary?.smartbox_usr_seat_count
                        ?.label_text ?? ""}
                    </p>
                  </div>
                </MDBCol>
              )} */}
              {accountSeatSummary?.seat_details_obj &&
                Object.entries(accountSeatSummary.seat_details_obj).map(([label, count]) => (
                  <>
                    <MDBCol style={{ width: "25%" }}>
                      <div className="p-3 border border-2  rounded-5 shadow-2-strong d-flex align-items-center justify-content-center flex-column">
                        <h1 className="m-0">{count}</h1>
                        <p>{label}</p>
                      </div>
                    </MDBCol>
                  </>
                ))}
            </MDBRow>
          </>
        )}
        {/* <h5 className="py-3">Contract Seats Report</h5> */}
        {/* <MDBTable>
          <MDBTableHead>
            <tr>
              <th scope="col">Seat Type</th>
              <th scope="col">Contract Seats Quantity</th>
              <th scope="col">Non-Contract Seats Quantity</th>
              <th scope="col">Total Quantity</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {contractSeatInfo &&
              contractSeatInfo?.length > 0 &&
              contractSeatInfo?.map((contract) => (
                <>
                  <tr>
                    <th scope="row">{contract?.seat_type}</th>
                    <td className="">{contract?.contrct_seat_count}</td>
                    <td className="">{contract?.noncontrct_seat_count}</td>
                    <td className="">{contract?.total_seat_count}</td>
                  </tr>
                </>
              ))}
          </MDBTableBody>
        </MDBTable> */}
        <MDBDatatable
          responsive
          fixedHeader
          sortField="Seat Type"
          hover
          pagination={false}
          data={billingDataContract}
        />
        {/* <div class="general-settings mt-4">Seat Summary</div>
        <div className="actionbar"></div>
        <div className="pb-5">
          <MDBDatatable
            responsive
            fixedHeader
            hover
            sortField="Service Name"
            pagination={false}
            data={billingData}
          />
        </div> */}
      </div>
    </>
  );
}

export default BillingContractSeatReport;
